import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Generator from '../Generator'
import { TileSkeleton } from '../Skeleton'
import { matchesStyle } from '../../utils/iconStyle'

// Placeholder tiles until this category's icons are in the store (a category can
// scroll in before the full icon list has loaded)
export const Category = ({ icons, entity, isHorizontal, styleFilter }) => {
	const categoryIcons = useMemo(() => icons.filter(icon => icon.cat === entity.cat_name), [icons, entity])
	return categoryIcons.length > 0 ? (
		<Generator entity={categoryIcons.filter(icon => matchesStyle(styleFilter, icon))} />
	) : (
		<TileSkeleton count={Math.min(entity.total || 21, 28)} listView={isHorizontal} />
	)
}

Category.propTypes = {
	icons: PropTypes.array.isRequired,
	entity: PropTypes.object.isRequired,
	isHorizontal: PropTypes.bool,
	styleFilter: PropTypes.string
}

Category.defaultProps = {
	styleFilter: 'all'
}
export default Category
